/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_3_1 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-23.478334388921603,-74.62106313206878],
                        [-28.180482826421603,-74.62106313206878],
                        [-28.180482826421603,-75.75519367487094],
                        [-23.478334388921603,-75.75519367487094],
                        [-23.478334388921603,-74.62106313206878]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_3_1